import $ from 'jquery'
import _ from 'underscore'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-lightbox')
    .each(function(i, el) {
      new LightBox(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

function LightBox() {
  this.initialize.apply(this, arguments)
}

$.extend(LightBox.prototype, {
  initialize: function(el) {
    var self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)
    self.items = []
    self.pswpElement = document.querySelectorAll('.pswp')[0]
    self.reloadItems = self.reloadItems.bind(self)
    self.reloadItems()

    self.$el.on('click', '.js-lightbox__image, .js-lightbox__video', function(
      event
    ) {
      event.preventDefault()
      var $index = self.$images.index(this)
      var options = {
        index: $index,
        history: false,
        closeOnScroll: false,
        correctOrientation: true,
        addCaptionHTMLFn: function(item, captionEl) {
          if (!item.title) {
            captionEl.children[0].innerText = ''
            return false
          }
          captionEl.children[0].innerHTML =
            item.title + '<br/><small>' + item.description + '</small>'
          return true
        }
      }
      var lightBox = new PhotoSwipe(
        self.pswpElement,
        PhotoSwipeUI_Default,
        self.items,
        options
      )
      lightBox.init()
      lightBox.listen('close', () => {
        $(lightBox.container)
          .find('.pswp__item')
          .eq(lightBox.getCurrentIndex() + 1)
          .find('.pswp__zoom-wrap')
          .html(lightBox.currItem.html)
      })
      lightBox.listen('beforeChange', diff => {
        $(lightBox.container)
          .find('.pswp__item')
          .eq(lightBox.getCurrentIndex() - diff + 1)
          .find('.pswp__zoom-wrap')
          .html(lightBox.currItem.html)
      })
    })
    if (self.$el.hasClass('js-scuba__list')) {
      self.$el.on('itemsChanged', function() {
        self.reloadItems()
      })
    }
  },
  reloadItems() {
    var self = this

    self.$images = self.$el.find('.js-lightbox__image, .js-lightbox__video')

    // build items array
    self.items = []

    self.$images.each(function(index, image) {
      var $img = $(image)
      if ($img.hasClass('js-lightbox__image')) {
        self.items.push({
          src: $img.attr('data-full-src'),
          msrc: $img.attr('data-src'),
          w: parseInt($img.attr('data-full-width')),
          h: parseInt($img.attr('data-full-height')),
          title: $img.attr('data-title'),
          description: $img.attr('data-description')
        })
      } else {
        self.items.push({
          html: $img.find('.js-lightbox__video__html').html()
        })
      }
    })
  }
})



// WEBPACK FOOTER //
// ./scripts/components/LightBox.js